import { isDefined } from "@clipboard-health/util-ts";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import {
  DOCUMENTS_BASE_PATH_FULL,
  WORKPLACE_DOCUMENTS_FULL_PATH,
} from "@src/appV2/redesign/Documents/paths";
import { generatePath, Redirect, useParams } from "react-router-dom";

/**
 * @deprecated
 * This container should no longer be used.
 * All usages should be updated to use the new redesigned documents pages, once all deep links are updated.
 */
export function DocumentsPageContainer() {
  const params = useParams<{ hcfId?: string; hcfName?: string }>();

  useLogEffect("legacy documents page container visited", {
    hcfId: params.hcfId,
    hcfName: params.hcfName,
  });

  if (isDefined(params.hcfId) && isDefined(params.hcfName)) {
    return (
      <Redirect
        to={generatePath(WORKPLACE_DOCUMENTS_FULL_PATH, {
          workplaceId: params.hcfId,
        })}
      />
    );
  }

  return <Redirect to={DOCUMENTS_BASE_PATH_FULL} />;
}
